import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Step } from "./constant";
import { useDispatch } from "react-redux";
import Joyride from "react-joyride";
import { updateActiveTourStep } from "../Redux/Slice/appTourSlice";
import Tooltip from "./Tooltip";

const Explainer = () => {
  const [{ run, steps }, setJoyRideConfig] = useState({
    run: false,
    steps: Step,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    setTimeout(
      () =>
        setJoyRideConfig((prev) => {
          return {
            ...prev,
            run:
              localStorage.getItem("isTourRunEligible") === "false"
                ? false
                : localStorage.getItem("isTourRunnig"),
          };
        }),
      300
    );
  }, []);

  return (
    <Joyride
      continuous
      run={run}
      steps={steps}
      disableScrolling={true}
      tooltipComponent={Tooltip}
      disableCloseOnEsc
      disableOverlayClose
      callback={(e) => {
        if (
          e.action === "close" ||
          e.action === "skip" ||
          e.lifecycle === "complete"
        ) {
          dispatch(updateActiveTourStep(0));
          localStorage.setItem("activeTourStep", 0);
          localStorage.setItem("isTourRunEligible", false);
        }
        dispatch(updateActiveTourStep(e?.index));
        localStorage.setItem("activeTourStep", e?.index);
      }}
    />
  );
};

export default Explainer;
